import React from "react";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";

function Header() {
  return (
    <header>
      <h1>
        {" "}
        <SpeakerNotesIcon />
        Keeper
      </h1>
    </header>
  );
}

export default Header;
